import * as WsCommandEnum from "../_ws/WsCommandEnum";
import * as Pagination from "./product-pagination";
import * as Utils from "../_ws/utils";
import * as Config from "../_ws/config";
import * as Toasts from "./toasts";

const command = WsCommandEnum.CONFIGURATOR

window.configuratorObj = {
};

function bind() {
    $('a.configurator').off('click').on('click', function(e){
        if (Utils.isWebsocketReady()) {
            e.stopPropagation();
            e.preventDefault();
        }
        let url = window.location.href;
        window.location.newHref = $(this).attr('href');
        Pagination.submitPagination(command, window.configuratorObj);
        window.history.pushState({}, '', url);
    });

    $('a.configurator-optional').off('click').on('click', function(e){
        if (Utils.isWebsocketReady()) {
            e.stopPropagation();
            e.preventDefault();
        }
        let url = window.location.href;
        window.location.newHref = $(this).attr('href');
        Pagination.submitPagination('configurator-optional', window.configuratorObj);
        window.history.pushState({}, '', url);
    });


    $('a.change-option').off('click').on('click', function(e){
        if (Utils.isWebsocketReady()) {
            e.stopPropagation();
            e.preventDefault();
        }
        let url = window.location.href;
        window.location.newHref = $(this).attr('href');
        Pagination.submitPagination(command, window.configuratorObj);
        window.history.pushState({}, '', url);
    });

    $('a.change-option-optional').off('click').on('click', function(e){
        if (Utils.isWebsocketReady()) {
            e.stopPropagation();
            e.preventDefault();
        }
        let url = window.location.href;
        window.location.newHref = $(this).attr('href');
        Pagination.submitPagination('configurator-optional', window.configuratorObj);
        window.history.pushState({}, '', url);
    });

    $('.toSummary').on('click', function(e) {
        if($('.config-tile').length <= 0){
            e.preventDefault()
            Toasts.createToast(['error', 'Nie wybrałeś żadnego elementu zestawu']);
        }
    })

    if($('.configurator-assembly-type').hasClass('current')){
        if(!$('.checkbox-icon').hasClass('fa-square-check')){
            $('.checkbox-icon').removeClass('fa-square').addClass('fa-square-check');
        }
    }

    $('.configurator-assembly-type').on('click', function (e){
        if($(this).hasClass('current')){
            $('.configurator-assembly-type').removeClass('current');
            $(this).find('.checkbox-icon').removeClass('fa-square-check').addClass('fa-square');
        } else{
            $('.configurator-assembly-type').removeClass('current');
            $(this).addClass('current');
            $('.checkbox-icon').removeClass('fa-square-check').addClass('fa-square');
            $(this).find('.checkbox-icon').removeClass('fa-square').addClass('fa-square-check')
        }

        if($('.configurator-assembly-type.current').length > 0){
            $('.proline-assembly').addClass('btn-success').removeClass('disabled').removeClass('btn-secondary')
            $('.self-assembly').addClass('disabled').addClass('btn-secondary').removeClass('btn-cyan')
        } else {
            $('.proline-assembly').addClass('disabled').removeClass('btn-success').addClass('btn-secondary');
            $('.self-assembly').removeClass('disabled').addClass('btn-cyan').removeClass('btn-secondary');
        }

    })


    $('.self-assembly').on('click', function() {
        if($('.self-assembly').hasClass('disabled')){
            Toasts.createToast(['danger', 'Odznacz złożenie komputera'])
        }
    })


    $('.proline-assembly').on('click', function(e) {
        e.preventDefault();

        const computerAssemblyType = $('.configurator-assembly-type.current')
        const productId = computerAssemblyType.data('pl-productid')
        const href = $('.proline-assembly').data('pl-href');
        const group = $('.proline-assembly').data('pl-group');

        let urlString = window.location.href;
        let command = WsCommandEnum.CONFIGURATOR_ASSEMBLY;
        let obj = {
            productId,
            href,
            group
        }

        if (Utils.isWebsocketReady()) {
            Utils.sendNewCommandMessage(command, {
                'cToken': Config.getProlineAppDataByKey('token'),
                'formData': obj,
            });
        } else {
            window.location.href = urlString;
        }
    })

    $('a.save-configurator').off('click').on('click', function(e) {
        e.preventDefault();
        let command = $(this).closest('form').data('ws');
        let urlString = window.location.href;
        let obj = {};
        $('.config-tile').each(function(i, e) {
            let supplierCode = $(e).data('pl-suppliercode');
            let groupCode = $(e).data('pl-groupcode');
            let productAmount = $(e).find('input.form-control').val();
            if(supplierCode.length > 0 && groupCode.length > 0 ) {
                obj[groupCode] = {product : supplierCode, amount: productAmount};
            }
        })

        if (Utils.isWebsocketReady()) {
            Utils.sendNewCommandMessage(command, {
                'cToken': Config.getProlineAppDataByKey('token'),
                'formData': obj,
            });
        } else {
            window.location.href = urlString;
        }
    });

    $('button.copy').off('click').on('click', function(e) {
        e.preventDefault();
        Toasts.createToast(['success', 'Link skopiowano do schowka']);
    });

    $('div.copy').off('click').on('click', function(e) {
        e.preventDefault();
        Toasts.createToast(['success', 'Skopiowano do schowka']);
    });

    $('h2.copy').off('click').on('click', function(e) {
        e.preventDefault();
        Toasts.createToast(['success', 'Skopiowano do schowka']);
    });
}

export {
    bind
}
